import dayjs from 'dayjs';

const isDateInFuture = (date?: string) => dayjs(date).valueOf() > dayjs().valueOf();

export default isDateInFuture;
